import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import useMemoSelector from 'hooks/useMemoSelector';

import { isOSThemeSupported } from 'utils/ui-helpers';

import generalSlice from 'store/general';
import { getIsOSThemeEnabled } from 'store/selectors/general';

function useListenSystemThemeChange() {
  const dispatch = useDispatch();
  const useOSTheme = useMemoSelector(getIsOSThemeEnabled);

  // @ts-ignore
  useEffect(() => {
    // TODO check return values
    if (isOSThemeSupported() && useOSTheme) {
      const updateState = (state: boolean) => {
        dispatch(generalSlice.actions.setIsDarkModeEnabled(state));
      };

      const changeTheme = (event: MediaQueryListEvent) => {
        updateState(event.matches);
      };

      updateState(window.matchMedia('(prefers-color-scheme: dark)').matches);

      window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', changeTheme);
      return () => {
        window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', changeTheme);
      };
    }
  }, [useOSTheme, dispatch]);
}

export default useListenSystemThemeChange;
